"use client";
import { jsx as a, jsxs as n, Fragment as b } from "react/jsx-runtime";
import { Paper as f, Link as y, Group as t, Heading as N, Illustration as x, Image as w, AnimatedButton as d, Paragraph as L, sharedHandler as v } from "@ingeniorforeningen/figurine-core";
import { forwardRef as B } from "react";
import '../../../assets/MultiBox.css';const M = "_root_1bul2_2", j = "_header_1bul2_20", P = "_heading_1bul2_30", W = "_illustration_1bul2_35", H = "_imageWrapper_1bul2_40", I = "_image_1bul2_40", $ = "_body_1bul2_52", z = "_link_1bul2_62", A = "_imageLink_1bul2_66", e = {
  root: M,
  header: j,
  heading: P,
  illustration: W,
  imageWrapper: H,
  image: I,
  body: $,
  link: z,
  imageLink: A
}, o = B((m, c) => {
  const {
    header: u,
    illustration: s,
    text: p,
    cta: r,
    fluid: h,
    variant: i = "dark",
    className: g,
    image: l,
    mod: _,
    ...k
  } = m;
  return /* @__PURE__ */ a(
    f,
    {
      className: `${e.root} ${g}`,
      ...k,
      ref: c,
      p: 0,
      mod: { variant: i, fluid: h, ..._ },
      children: /* @__PURE__ */ a(y, { p: 0, href: r.href, target: r.target, children: /* @__PURE__ */ n(b, { children: [
        /* @__PURE__ */ n(
          t,
          {
            className: e.header,
            p: "md",
            justify: "space-between",
            wrap: "nowrap",
            spacing: "md",
            mod: { variant: i },
            children: [
              /* @__PURE__ */ a(
                N,
                {
                  type: "h3",
                  text: u,
                  className: e.heading,
                  variant: "light",
                  mod: { variant: i }
                }
              ),
              s && /* @__PURE__ */ a(t, { className: e.illustration, p: "xs", children: /* @__PURE__ */ a(x, { name: s, variant: "dark", height: "auto", width: "auto" }) })
            ]
          }
        ),
        /* @__PURE__ */ n(t, { direction: "column", className: e.body, mod: { variant: i }, children: [
          l && /* @__PURE__ */ n(t, { className: e.imageWrapper, children: [
            /* @__PURE__ */ a(
              w,
              {
                ...l,
                width: "100%",
                className: e.image,
                caption: void 0,
                byline: void 0,
                orientation: "landscape",
                sizes: "350px"
              }
            ),
            /* @__PURE__ */ a(
              t,
              {
                direction: "column",
                className: e.body,
                mx: "lg",
                py: "md",
                mod: { variant: i },
                children: /* @__PURE__ */ a(
                  d,
                  {
                    link: { href: r.href },
                    variant: i === "spot" ? "light" : "dark",
                    className: e.imageLink,
                    useParentLink: !0
                  }
                )
              }
            )
          ] }),
          !l && /* @__PURE__ */ n(
            t,
            {
              direction: "column",
              mx: "lg",
              py: "md",
              h: "100%",
              mod: { variant: i },
              justify: "space-between",
              children: [
                /* @__PURE__ */ a(
                  L,
                  {
                    lineClamp: 6,
                    text: p,
                    variant: i === "spot" ? "light" : "dark",
                    condensed: !0
                  }
                ),
                /* @__PURE__ */ a(
                  d,
                  {
                    link: r,
                    variant: i === "spot" ? "light" : "dark",
                    className: e.link,
                    useParentLink: !0
                  }
                )
              ]
            }
          )
        ] })
      ] }) })
    }
  );
});
o.displayName = "MultiBox";
const C = v(o);
C.displayName = o.displayName;
export {
  e as M,
  o as _MultiBox,
  C as default
};
